import * as SwitchPrimitive from '@radix-ui/react-switch'
import * as React from 'react'

import { cn } from '../../lib/utils'

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'bg-border-strong relative inline-flex h-6 w-10.5 shrink-0 cursor-pointer items-center rounded-full border border-transparent p-0 transition-colors duration-100 ease-out outline-none',
        'focus-visible:outline-accent focus-visible:outline-2 focus-visible:outline-offset-1',
        'data-[state=checked]:bg-fg',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb className="bg-bg-elev shadow-raise block size-5 translate-x-0.5 rounded-full transition-transform duration-100 ease-out data-[state=checked]:translate-x-4.5" />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
